import React from "react";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as userSelectors } from "../../../../redux/user";
import { Checkbox, Button } from "@vitalsource/vstui";
import { Translation, t } from "../../../core/translate";

export const Terms = ({ showTerms, skipTOS, termsURL, cookieURL, privacyURL }) =>
  (!skipTOS && showTerms) ? (
    <Checkbox
      fullWidth
      id="tos"
      name="user[eula_accepted]"
      data-key="tos"
      className="no-checkbox"
      label={
        <Translation
          id="registration.accept-tos-fill-links"
          eulaURL={
            <Button
              href={termsURL || t("locations.zendesk-tou", "#")}
              target="_blank"
              inline
            >
              <Translation id="main-menu.terms">Terms of Use</Translation>
            </Button>
          }
          privacyURL={
            <Button
              href={privacyURL || t("locations.zendesk-privacy", "#")}
              target="_blank"
              inline
            >
              <Translation id="main-menu.privacy-policy">
                Privacy Policy
              </Translation>
            </Button>
          }
          cookieURL={
            <Button
              href={cookieURL || t("locations.zendesk-cookies", "#")}
              target="_blank"
              inline
            >
              <Translation id="main-menu.cookie-policy">
                Cookie Policy
              </Translation>
            </Button>
          }
        >
          I agree to the Terms of Use, Privacy Policy, and Cookie Policy.
        </Translation>
      }
      required
    />
  ) : null;

const mapStateToProps = state => ({
  showTerms: !userSelectors.hasAcceptedTOU(state),
  // If the brand does not override these urls, we fall back to the translation
  skipTOS: brandSelectors.getBrandValue(state, "AccountCompletion.skipTOS", false),
  termsURL: brandSelectors.getBrandValue(state, "Terms.url", false),
  cookieURL: brandSelectors.getBrandValue(state, "Cookies.url", false),
  privacyURL: brandSelectors.getBrandValue(state, "Privacy.url", false)
});

export default connect(mapStateToProps)(Terms);
